/* ==========================================================================
   STICK'IT — SKIN : PAGES DE CONTENU (après stickit.js et skin.js)
   Additif : n'appelle ni ne patche aucune fonction de stickit.js. Lit l'état
   posé par initCustom (.tier.on, .drop.filled, .recap-row.empty) sans jamais
   écrire dans les éléments du contrat, sauf des classes/variables sk-*.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* 1. Clavier : paliers et zone de dépôt activables à Entrée / Espace
     (le clic reste géré par initCustom). */
  function keyActivate(els) {
    els.forEach(function (el) {
      el.addEventListener('keydown', function (ev) {
        if (ev.target !== el || (ev.key !== 'Enter' && ev.key !== ' ')) return;
        ev.preventDefault();
        el.click();
      });
    });
  }

  /* 2. Aperçu du visuel déposé : vignette « sticker » tant que .drop.filled. */
  function dropThumb() {
    var drop = doc.querySelector('.drop'), input = doc.getElementById('file-input');
    if (!drop || !window.URL || !URL.createObjectURL) return;
    var url = '';
    function clear() {
      drop.classList.remove('sk-has-thumb');
      drop.style.removeProperty('--sk-thumb');
      if (url) { URL.revokeObjectURL(url); url = ''; }
    }
    function show(file) {
      // initCustom a déjà validé (ou refusé) le fichier : on suit son verdict
      setTimeout(function () {
        if (!file || !drop.classList.contains('filled')) return;
        if (url) URL.revokeObjectURL(url);
        url = URL.createObjectURL(file);
        drop.style.setProperty('--sk-thumb', 'url("' + url + '")');
        drop.classList.add('sk-has-thumb');
      }, 0);
    }
    if (input) input.addEventListener('change', function () { show(input.files && input.files[0]); });
    drop.addEventListener('drop', function (e) { show(e.dataTransfer && e.dataTransfer.files[0]); });
    new MutationObserver(function () {
      // garde : clear() modifie elle-même la classe (sinon boucle d'observation)
      if (!drop.classList.contains('filled') && drop.classList.contains('sk-has-thumb')) clear();
    }).observe(drop, { attributes: true, attributeFilter: ['class'] });
  }

  /* 3. Récapitulatif vivant : la valeur qui change « se pose », la barre
     de progression suit le nombre de lignes renseignées. */
  function recap() {
    var box = doc.querySelector('.recap');
    if (!box) return;
    var rows = $$('.recap-row', box);
    function fill() {
      var n = rows.filter(function (r) { return !r.classList.contains('empty'); }).length;
      box.style.setProperty('--sk-fill', rows.length ? (n / rows.length).toFixed(3) : 0);
    }
    $$('[data-recap]', box).forEach(function (b) {
      var last = b.textContent;
      new MutationObserver(function () {
        if (b.textContent === last) return;
        last = b.textContent;
        b.classList.remove('sk-flash'); void b.offsetWidth; b.classList.add('sk-flash');
        fill();
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
    fill();
  }

  /* 4. Pages légales : le sommaire suit la section en cours de lecture. */
  function legalToc() {
    var toc = doc.querySelector('.legal-toc');
    if (!toc || !('IntersectionObserver' in window)) return;
    var links = $$('a[href^="#"]', toc), map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var heads = $$('.prose h2[id]').filter(function (h) { return map[h.id]; });
    if (!heads.length) return;
    function set(id) {
      links.forEach(function (a) { a.classList.toggle('sk-on', a === map[id]); });
    }
    var visible = {};
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
      var cur = null;
      heads.forEach(function (h) { if (visible[h.id] && !cur) cur = h.id; });
      if (!cur) {
        // entre deux titres : la dernière section passée au-dessus du milieu
        heads.forEach(function (h) { if (h.getBoundingClientRect().top < innerHeight * 0.5) cur = h.id; });
      }
      set(cur || heads[0].id);
    }, { rootMargin: '-15% 0px -45% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }

  function boot() {
    keyActivate($$('.tier[data-price][tabindex], .drop[tabindex]'));
    dropThumb();
    recap();
    legalToc();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Contact : zone de dépôt d'image (même aspect que « Ton custom ») — gérée ici car initCustom ne s'active que sur Ton custom.
   L'image reste dans le navigateur : rien n'est envoyé tant que le formulaire n'est pas branché. */
(function () {
  var drop = document.querySelector('[data-sk-drop]');
  if (!drop) return;
  var input = document.getElementById(drop.getAttribute('data-sk-drop'));
  var b = drop.querySelector('b'), sp = drop.querySelector('span'), clear = drop.querySelector('.clear'), thumb = drop.querySelector('.sk-drop-thumb');
  var B0 = b.textContent, S0 = sp.textContent, url = null;
  function reset() { if (url) URL.revokeObjectURL(url); url = null; input.value = ''; drop.classList.remove('filled'); b.textContent = B0; sp.textContent = S0; if (thumb) thumb.style.backgroundImage = ''; }
  function take(f) {
    if (!f) return;
    if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { sp.textContent = 'Format non pris en charge : JPG, PNG ou WEBP.'; return; }
    if (f.size > 12 * 1024 * 1024) { sp.textContent = 'Image trop lourde : 12 Mo maximum.'; return; }
    if (url) URL.revokeObjectURL(url); url = URL.createObjectURL(f);
    drop.classList.add('filled'); b.textContent = f.name; sp.textContent = Math.round(f.size / 1024) + ' Ko · image prête';
    if (thumb) { thumb.style.backgroundImage = 'url("' + url + '")'; thumb.style.backgroundSize = 'cover'; thumb.style.backgroundPosition = 'center'; }
  }
  drop.addEventListener('click', function (e) { if (e.target === clear || e.target.closest('.clear')) { e.preventDefault(); reset(); return; } input.click(); });
  drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
  input.addEventListener('change', function () { take(input.files[0]); });
  ['dragenter', 'dragover'].forEach(function (n) { drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.add('over'); }); });
  ['dragleave', 'drop'].forEach(function (n) { drop.addEventListener(n, function (e) { e.preventDefault(); drop.classList.remove('over'); }); });
  drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) { try { var dt = new DataTransfer(); dt.items.add(f); input.files = dt.files; } catch (x) {} take(f); } });
})();
/* Ton custom : l'illustration du bandeau se masque si le texte (titre, accroche) l'atteint,
   quelle que soit la langue (les titres traduits n'ont pas la même longueur). */
(function () {
  var art = document.querySelector('.page-custom .sk-band-art'); if (!art) return;
  var band = art.closest('.strate-band'), frame = 0;
  function textRight(top, bottom) {
    var max = 0, r = document.createRange(), tw = document.createTreeWalker(band, 4), n;
    while ((n = tw.nextNode())) {
      if (art.contains(n) || !n.nodeValue.trim()) continue;
      r.selectNodeContents(n);
      var rs = r.getClientRects();
      for (var i = 0; i < rs.length; i++) if (rs[i].bottom > top && rs[i].top < bottom) max = Math.max(max, rs[i].right);
    }
    var hl = band.querySelector('h1 em');             // surlignage rose du titre, plus large que son texte
    if (hl) { var q = hl.getBoundingClientRect(); if (q.bottom > top && q.top < bottom) max = Math.max(max, q.right); }
    return max;
  }
  function fit() {                                    // d'abord rétrécir (calée à droite), masquer en dernier recours
    frame = 0;
    art.classList.remove('sk-ba-off'); art.style.width = '';
    var a = art.getBoundingClientRect(), w0 = a.width; if (!w0) return;
    for (var k = 0; k < 4 && textRight(a.top, a.bottom) + 24 > a.left; k++) {
      art.style.width = Math.round(w0 * (0.82 - k * 0.12)) + 'px';
      a = art.getBoundingClientRect();
    }
    if (textRight(a.top, a.bottom) + 24 > a.left) art.classList.add('sk-ba-off');
  }
  function later() { if (!frame) frame = requestAnimationFrame(fit); }
  addEventListener('resize', later);
  addEventListener('load', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  new MutationObserver(later).observe(band.querySelector('.wrap'), { subtree: true, childList: true, characterData: true });
  later();
})();